<template>
  <div class="about">
    <mainmenu />
    <h1>This is an about page</h1>
  </div>
</template>

<script>
export default {

    components: {
        'mainmenu': require('@/components/MainMenu.vue').default 
    }
}
</script>